import './switch.css';
export default {
  "dirRtl": "pf-v6-m-dir-rtl",
  "modifiers": {
    "reverse": "pf-m-reverse"
  },
  "switch": "pf-v6-c-switch",
  "switchInput": "pf-v6-c-switch__input",
  "switchLabel": "pf-v6-c-switch__label",
  "switchToggle": "pf-v6-c-switch__toggle",
  "switchToggleIcon": "pf-v6-c-switch__toggle-icon"
};